import React from 'react'
import { Stack } from '@chakra-ui/react'
import type { StackProps } from '@chakra-ui/react'
import type { PinInputProps } from '@chakra-ui/react'
import { PinInput, PinInputField } from '@chakra-ui/react'

interface Props extends Omit<PinInputProps, 'children'> {
    onSubmit?: () => void
    codeLength?: number
    containerOverrides?: StackProps
}

export default function CodeInput({
    onSubmit,
    codeLength = 6,
    containerOverrides,
    ...props
}: Props) {
    return (
        <Stack direction="row" spacing={4} {...containerOverrides}>
            <PinInput autoFocus focusBorderColor="blue.500" {...props}>
                {[...Array(codeLength)].map((_, index) => (
                    <PinInputField
                        key={index}
                        onKeyDown={e => {
                            if (e.key === 'Enter' && onSubmit) {
                                onSubmit()
                            }
                        }}
                    />
                ))}
            </PinInput>
        </Stack>
    )
}
